import * as types from './constants'

export const process = (response) => ({
  type: types.DETAILS_LOADED,
  address: response.address,
  capacity: response.capacity,
  operational_profile: response.operational_profile,
})


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/actions.js